<template>
  <div>
    <DSelect :items="items"
             :itemsSelected="selectedItems"
             :itemsThatCantBeDeleted="itemsThatCantBeDeleted"
             :multiple="isMultiple"
             :placeholder="i18n[locale]['search']"
             :appendToBody="appendToBody"
             :calculate-position="withPopper"
             :show="show"
             :showCreateButton="showCreateButton"
             :newUserCalendarId="newUserCalendarId"
             @update="setSelectedItems"
             @add="add"
             @remove="remove"
             @createNew="createNew">
    </DSelect>
  </div>
</template>

<script>
import DSelect from './DSelectCals'
import {createPopper} from '@popperjs/core'
import {mapGetters} from 'vuex'
import docendo from '../../docendo'

export default {
  components: {DSelect},
  props: {
    calendarId: {
      default: null
    },
    itemType: {
      default: 'user'
    },
    preSelectedItems: {
      default: () => []
    },
    itemsThatCantBeDeleted: {
      default: () => []
    },
    showTags: {
      type: Boolean,
      default: false
    },
    isMultiple: {
      type: Boolean,
      default: true
    },
    showCreateButton: {
      type: Boolean,
      default: false
    },
    appendToBody: {
      type: Boolean,
      default: true
    },
    show: {
      default: false,
      type: Boolean
    },
    calendarIdsToHide: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    ...mapGetters([
      'klassCalendars',
      'userCalendars',
      'roomCalendars',
      'clubCalendars',
      'allUsersInCalIdHash',
      'locale'
    ]),
    school () {
      return this.$store.state.activeSchool
    },
    items () {
      if (this.itemType.toLowerCase() === 'user') {
        if (!this.showTags) {
          return this.userCalendars.filter(calendar => {
            if (!this.calendarIdsToHide || this.calendarIdsToHide.length === 0) {
              return true // Returnér alle, hvis ingen ID'er skal skjules
            }
            return !this.calendarIdsToHide.some(calId => calId === calendar.id) // Filtrer dem, der ikke skal skjules
          })
        }
        let userCalsWithTags = this.userCalendars.map(cal => {
          let tags = this.allUsersInCalIdHash[cal.id] && this.allUsersInCalIdHash[cal.id].user_tags ? this.allUsersInCalIdHash[cal.id].user_tags : []
          this.$set(cal, 'user_tags', tags)
          return cal
        })
        this.tags.forEach(tag => {
          userCalsWithTags.push(tag)
        })
        return userCalsWithTags
      }
      if (this.itemType.toLowerCase() === 'room') {
        return this.roomCalendars
      }
      if (this.itemType.toLowerCase() === 'club') {
        return this.calendarId ? this.clubCalendars.filter(calendar => calendar.id !== this.calendarId) : this.clubCalendars
      }
      if (this.itemType.toLowerCase() === 'klass') {
        return this.calendarId ? this.klassCalendars.filter(calendar => calendar.id !== this.calendarId) : this.klassCalendars
      }
    },
    activeSchoolYear () {
      return this.$store.state.localActivatedSchoolYear
    }
  },
  data () {
    return {
      isLoaded: false,
      tags: [],
      selectedItems: [],
      searchText: '',
      placement: 'bottom',
      i18n: {
        da: {
          search: 'Søg og vælg'
        },
        en: {
          search: 'Search and choose'
        },
        nb: {
          search: 'Søk og velg'
        }
      },
      newUserCalendarId: null
    }
  },
  watch: {
    items (val, oldVal) {
      if (val.length > 0) {
        this.setPreSelectedItems()
      }
    }
  },
  methods: {
    withPopper (dropdownList, component, {width}) {
      dropdownList.style.width = width
      createPopper(component.$refs.toggle, dropdownList, {
        placement: this.placement,
        modifiers: [
          {
            name: 'offset', options: {
              offset: [0, 0]
            }
          },
          {
            name: 'toggleClass',
            enabled: true,
            phase: 'write',
            fn ({state}) {
              component.$el.classList.toggle('openFromBottom', state.placement === 'top')
            }
          }]
      })
    },
    add (item) {
      // this.$emit('add', item)
    },
    remove (item) {
      // this.$emit('remove', item)
    },
    setSelectedItems (val) {
      this.selectedItems = []
      this.selectedItems = val
      this.$emit('update', this.selectedItems)
    },
    isInSelectedItems (calid) {
      return this.selectedItems.findIndex(item => item && item.id === calid) >= 0
    },
    setPreSelectedItems () {
      this.preSelectedItems.forEach(userCalendarId => {
        if (userCalendarId) {
          if (!this.isInSelectedItems(userCalendarId)) {
            const idx = this.items.findIndex(item => item.id === userCalendarId)
            if (idx > -1) {
              this.selectedItems.push(this.items[idx])
            } else {
              console.log('cant find', userCalendarId)
            }
          }
        }
      })
      if (!this.showTags) {
        this.isLoaded = true
      }
    },
    getTags () {
      docendo.schoolTags(this.school.id, data => {
        let tags = []
        let i = 0
        data.forEach(tag => {
          i++
          let oneTag = {
            tag: true,
            id: 999999999999 + i,
            name: tag,
            icon: 'icon-price-tag2'
          }
          tags.push(oneTag)
        })
        this.tags = tags
      })
    },
    createNew (evt) {
      if (this.itemType === 'room') {
        let calendars = [{name: evt, type: this.itemType}]
        docendo.schoolBulkCreateCalendars(window.SCHOOL.id, this.activeSchoolYear.id, calendars, success => {
          console.log('success', success)
        }, failure => {
          console.log('failure', failure)
        })
        return
      }
      if (this.itemType === 'user') {
        let users = [{name: evt}]
        docendo.schoolUsersCreate(this.school.id, users, success => {
          this.$store.dispatch('getSchoolCalendars', this.school.id)
          this.newUserCalendarId = success[0].user_calendar_id
          console.log('newUserCalendarId', this.newUserCalendarId)
        }, failure => {
          console.log('failure', failure)
        })
      }
    }
  },
  mounted () {
    if (this.showTags) {
      this.getTags()
    }
    this.setPreSelectedItems()
  }
}
</script>



// WEBPACK FOOTER //
// DSelectCalsIds.vue?62e8904d